<template>
  <div class="row">
    <label class="control-label col-sm-2">{{fileSlot.title}}:</label>
    <div class="col-sm-7">
      <div class="row">
        <UploadForm v-if="uploadUrl && canUpload"
                    accept="*/*"
                    @uploadComplete="uploadComplete"
                    @uploadError="uploadError"
                    :multiple="true"
                    :label="''"
                    labelIconClass="icon-add"
                    :showHint="true"
                    :uploadUrl="uploadUrl"
                    :fileSlot="fileSlot.code"
        ></UploadForm>
      </div>
      <div v-if="waitingUploadVisible" class="alert alert-bordered alert-warning">
        <p>
          Waiting for upload
        </p>
      </div>
      <template v-else-if="$fileslot.getSlotWorkflowState(parentObject, fileSlot.code)">
        <template v-if="!slotStatus(fileSlot.code, workflowName).match(/^rejected/) && !slotApproved(fileSlot.code, workflowName) && isRequiredState">
          <div class="alert alert-boxed alert-warning">
            <p v-if="!slotApproved(fileSlot.code, workflowName)">
              <span class="text-bold">Financial</span> approval pending
            </p>
          </div>
        </template>
        <template v-else-if="slotStatus(fileSlot.code, workflowName).match(/^rejected/)">
          <div class="alert alert-bordered alert-danger" :class="{'mb-0': slotStatusReason(fileSlot.code, workflowName)}">
            <p v-if="slotStatus(fileSlot.code, workflowName) === 'rejected'">
              <span class="text-bold">Financial</span> rejected documents
            </p>
          </div>
          <div v-if="slotStatusReason(fileSlot.code, workflowName)" class="alert alert-bordered bg-grey">
            {{slotStatusReason(fileSlot.code, workflowName)}}
          </div>
        </template>
      </template>
      <div class="row">
        <!-- medialist try -->
        <model-files-list :fileSlot="fileSlot" :canDeleteFile="canDeleteFile" :files="files" @deleteFile="deleteFile"></model-files-list>
        <!-- /medialist try -->
      </div>
    </div>
    <div class="col-sm-3">
      <template v-if="slotOkay(fileSlot.code) && $fileslot.getSlotWorkflowState(parentObject, fileSlot.code)">
        <template v-if="allowReview">
          <a @click.prevent="sendSlotToReview(fileSlot.code)" class="btn btn-primary">Submit on review</a>
        </template>
        <template v-if="allowApproveReject">
          <template v-if="actionsVisible">
            <a @click.prevent="approveSlot(fileSlot.code, workflowApprovedStatus)" class="btn btn-success mr-10">Approve</a>
            <a @click.prevent="rejectSlot(fileSlot.code, workflowRejectedStatus)" class="btn btn-danger">Reject</a>
          </template>
          <template v-else-if="rejectedVisible">
            <div class="alert alert-bordered pt-5">
              <span class="text-danger mr-10">REJECTED</span>
              <a class="btn btn-default" title="Undo choice" @click.prevent="unrejectSlot(fileSlot.code)"><i class="icon-cross2"></i></a>
            </div>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import ModelFilesList from './ModelFilesList'
import UploadForm from '@/components/_partial/UploadForm'

export default {
  name: 'SlotViewCredit',
  components: { ModelFilesList, UploadForm },

  props: {
    'parentObject': {
      type: Object,
      required: false
    },
    'files': {
      type: Array,
      required: false
    },
    'fileSlot': {
      type: Object,
      required: true
    },
    'canUpload': {
      type: Boolean,
      required: false,
      default: false
    },
    'canDeleteFile': {
      type: Boolean,
      required: false,
      default: false
    },
    'uploadUrl': {
      type: String,
      required: true
    },
    //
    'isRequiredState': {
      type: Boolean,
      required: false,
      default: true
    },
    //
    'workflowName': {
      type: String
    },
    'workflowApprovedStatus': {
      type: [String, Array]
    },
    'workflowRejectedStatus': {
      type: [String, Array]
    },
    //
    'allowReview': {
      type: Boolean,
      required: false,
      default: false
    },
    'allowApproveReject': {
      type: Boolean,
      required: false,
      default: false
    },
    'actionsVisible': {
      type: Boolean,
      required: false,
      default: false
    },
    'rejectedVisible': {
      type: Boolean,
      required: false,
      default: false
    },
    'waitingUploadVisible': {
      type: Boolean,
      required: false
    },
    //
    'deleteFile': {
      type: Function,
      required: false
    }
  },

  methods: {
    slotOkay (slotCode) {
      if (this.parentObject) {
        return this.$fileslot.slotFilled(this.parentObject, slotCode)
      }
      return false
    },

    slotApproved (slot, workflow = 'sale-credit-slot') {
      let targetState = ['approved']
      return this.slotStatusIn(targetState, slot, workflow)
    },

    slotApprovedBy (role, slot, workflow = 'sale-slot') {
      let targetState = ['approved_by_saad']
      if (role === 'agencyAdmin') {
        targetState.unshift('approved_by_senior')
      }
      return this.slotStatusIn(targetState, slot, workflow)
    },

    slotsApprovedBy (role, slots) {
      let result = true
      for (let i in slots) {
        result = this.slotApprovedBy(role, slots[i])
        if (!result) {
          break
        }
      }
      return result
    },

    slotStatusIn (statuses, slotCode, workflow = 'sale-slot') {
      let result = false
      if (Array.isArray(statuses)) {
        for (let i in statuses) {
          if (statuses[i] === this.slotStatus(slotCode, workflow)) {
            result = true
          }
        }
      }
      return result
    },

    slotStatus (slotCode, workflow = 'sale-slot') {
      let slotObject = this.$fileslot.__getSlotByCode(this.parentObject, slotCode)
      let result = ''
      if (slotObject) {
        result = this.$workflow.getFlowStatus(slotObject, workflow)
      }
      return result || ''
    },

    slotStatusReason (slotCode, workflow = 'sale-slot') {
      let slotObject = this.$fileslot.__getSlotByCode(this.parentObject, slotCode)
      let result = ''
      if (slotObject) {
        result = this.$workflow.getFlowStatusReason(slotObject, workflow)
      }
      return result || ''
    },
    //
    sendSlotToReview () {
      this.$emit('slotSentToReview', this.fileSlot.code)
    },

    approveSlot (slotCode, status = null, callback = null) {
      let data = {
        code: slotCode,
        title: this.fileSlot.title
      }
      if (status !== null) {
        data.status = status
      }
      if (callback !== null) {
        data.callback = callback
      }
      this.$emit('approveSlot', data)
    },

    rejectSlot (slotCode, status = null, callback = null) {
      let data = {
        code: slotCode
      }
      if (status !== null) {
        data.status = status
      }
      if (callback !== null) {
        data.callback = callback
      }
      this.$emit('rejectSlot', data)
    },

    unrejectSlot (slotCode, callback = null) {
      let data = {
        code: slotCode
      }
      if (callback !== null) {
        data.callback = callback
      }
      this.$emit('unrejectSlot', data)
    },

    //
    uploadComplete (data) {
      this.$emit('uploadComplete', data)
    },
    uploadError (data) {
      this.$emit('uploadError', data)
    }
  }
}
</script>

<style scoped>

</style>
